import { ActionType } from 'typesafe-actions';
import * as actions from './actions';
import {
    BILLING_ADDRESS,
    COMPANY,
    CITY,
    DIFFERENT_DATA,
    POST_CODE,
    STREET,
    STREET_NUMBER,
    TAX_ID_NUMBER,
    ORDER_TYPE,
    PAYER_ADDRESS,
    PAYMENT_METHOD,
    PHONE_NUMBER,
    REALIZATION_DATE,
    SCHOOL_EMAIL,
    SHIPPING_ADDRESS,
    SHIPPING_FORM,
    FIRST_NAME,
    LAST_NAME,
    CUSTOMER_EMAIL,
    NOTES,
} from 'views/pages/Checkout/common/constants';

export const FETCH_CHECKOUT_DATA_FAILED = 'FETCH_CHECKOUT_DATA_FAILED';
export const FETCH_CHECKOUT_DATA_SUCCEEDED = 'FETCH_CHECKOUT_DATA_SUCCEEDED';
export const FETCH_CHECKOUT_DATA_REQUEST = 'FETCH_CHECKOUT_DATA_REQUEST';
export const SET_CHECKOUT_VALUES = 'SET_CHECKOUT_VALUES';
export type InfoAction = ActionType<typeof actions>;

export type CheckoutValues = {
    [BILLING_ADDRESS]: {
        [COMPANY]: string;
        [CITY]: string;
        [POST_CODE]: string;
        [STREET]: string;
        [STREET_NUMBER]: string;
        [TAX_ID_NUMBER]: string;
    };
    [CUSTOMER_EMAIL]: string;
    [DIFFERENT_DATA]: boolean;
    [NOTES]: string;
    [ORDER_TYPE]: string;
    [PAYER_ADDRESS]: {
        [COMPANY]: string;
        [CITY]: string;
        [POST_CODE]: string;
        [SCHOOL_EMAIL]: string;
        [STREET]: string;
        [STREET_NUMBER]: string;
        [TAX_ID_NUMBER]: string;
    };
    [PAYMENT_METHOD]: string;
    [REALIZATION_DATE]: string;
    [SHIPPING_ADDRESS]: {
        [COMPANY]: string;
        [CITY]: string;
        [FIRST_NAME]: string;
        [LAST_NAME]: string;
        [PHONE_NUMBER]: string;
        [POST_CODE]: string;
        [STREET]: string;
        [STREET_NUMBER]: string;
        [TAX_ID_NUMBER]: string;
    };
    [SHIPPING_FORM]: string;
};
